import React from 'react';

import PropTypes from 'prop-types';

import { LayoutContainer as ContainerQueryLayoutContainer } from './container-query/layout-container';
import { LayoutContainer as ResizeObserverLayoutContainer } from './resize-observer-fallback/layout-container';
import { doesBrowserSupportContainerQuery } from '../../../../services/browser-support-service';

export const ShipmentDetailsLayoutLoader = (props) => {
  if (doesBrowserSupportContainerQuery) {
    return <ContainerQueryLayoutContainer {...props} />;
  }

  return <ResizeObserverLayoutContainer {...props} />;
};

ShipmentDetailsLayoutLoader.propTypes = {
  addressColumnContent: PropTypes.node.isRequired,
  costSummaryColumnContent: PropTypes.node.isRequired,
  datesColumnContent: PropTypes.node.isRequired,
  assignmentColumnContent: PropTypes.node.isRequired,
};
